<template>
  <v-app>
    <v-container>
      <v-row class="align-center justify-center">
        <v-col class="col-12">
          <v-form>
            <v-container fill-height class="pb-0">
              <v-row class="justify-center">
                <v-col class="col-12 col-sm-8 pb-0">
                  <h2 class="gray--text font-weight-bold text-h4 text-center">
                    Terapeuta Chefe
                  </h2>
                  <div
                    class="bg-lightGray color-darkGray text-center pa-3 pa-md-5 mt-5"
                  >
                    O Terapeuta Chefe é uma ferramenta do Ondivan que
                    possibilita o contacto directo entre si e a Responsável
                    Técnica pela plataforma. Poderá tirar dúvidas e receber
                    orientação para uma melhor prestação do serviço psicológico
                    on-line! Esta é uma etapa obrigatória para que possa atender
                    no nosso site que nos possibilitará aferir a capacidade
                    técnica de ambas as partes para além de estreitar os laços
                    humanos que serão sempre o nosso diferencial e a base dos
                    nossos atendimentos. Preencha este form e agende o primeiro
                    contacto gratuitamente!
                  </div>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Já exerce a clínica Psicológica há quanto tempo?
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.how_long_time_works"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Possui experiência no atendimento on-line? Se sim, nos
                        fale um pouco sobre ela.
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_experience"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Caso não possua, deseja receber orientações nesse
                        âmbito?
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.need_orientation"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Possui alguma especialidade técnica? Qual?
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_some_tecnical_experience"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Já passou por alguma dificuldade de ordem técnica
                        durante os atendimentos on-line (caso possua esta
                        experiência)? Em caso positivo, como a solucionou
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_experienced_technical_difficulties"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Como chegou ao Ondivan?
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.how_knows_ondivan"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="col-6 col-lg-3">
                      <div
                        class="bg-lightGray d-flex align-center justify-center caption text-md-body-1 color-darkGray text-left pa-3 pa-md-5 input-entrevista"
                      >
                        Possui alguma dúvida que não tenha sido mencionada neste
                        form? Qual?
                      </div>
                    </v-col>
                    <v-col class="col-6 col-lg-9">
                      <v-textarea
                        class="input-entrevista"
                        readonly
                        solo
                        flat
                        height="100%"
                        background-color="#ededed"
                        hide-details="auto"
                        v-model="form.have_other_questions"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>
      <div class="text-center mb-3">
        <v-btn color="success" width="150" large @click="$router.go(-1)"
          >Voltar</v-btn
        >
      </div>
    </v-container>
  </v-app>
</template>

<script>
import { getProfile } from '../../services/psychologists';

export default {
  name: 'ViewInterviewPsychologist',
  data() {
    return {
      form: {
        how_long_time_works: '',
        have_experience: '',
        need_orientation: '',
        have_some_tecnical_experience: '',
        have_experienced_technical_difficulties: '',
        how_knows_ondivan: '',
        have_other_questions: '',
      },
      loading: false,
    };
  },
  methods: {
    async pegaPerfil() {
      this.loading = true;
      const res = await getProfile(this.$route.params.id);
      console.log(res);
      this.form.how_long_time_works =
        res.psychologist_questions.how_long_time_works;
      this.form.have_experience = res.psychologist_questions.have_experience;
      this.form.need_orientation = res.psychologist_questions.need_orientation;
      this.form.have_some_tecnical_experience =
        res.psychologist_questions.have_some_tecnical_experience;
      this.form.have_experienced_technical_difficulties =
        res.psychologist_questions.have_experienced_technical_difficulties;
      this.form.how_knows_ondivan =
        res.psychologist_questions.how_knows_ondivan;
      this.form.have_other_questions =
        res.psychologist_questions.have_other_questions;

      this.loading = false;
    },
  },
  created() {
    this.pegaPerfil();
  },
};
</script>

<style scoped>
* >>> .input-entrevista,
* >>> .input-entrevista.v-text-field--solo .v-input__control {
  height: 100%;
}
</style>
